export const INITIAL_SESSIONS_SHOWN_COUNT = 4;
